import { Col } from "react-bootstrap";
import TeamMember from "./TeamMember";
import "./TeamMemberList.css";

function TeamMemberList({ teamMembers, language }) {
  return (
    <Col className="objectives-list">
      {teamMembers.map((element) => (
        <TeamMember
          key={element._id}
          id={element._id}
          name={element.name}
          indicators={element.indicators}
          language={language}
        />
      ))}
    </Col>
  );
}

export default TeamMemberList;
